export default __webpack_public_path__ + "static/media/infiniwell_PMS_logo-id.436c1d32.png";